import styled from 'styled-components'

export const Tiles = styled.div`
  background: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
  color: ${({ theme }) => theme.webMktNewPalette.black};
  padding: 96px 16px 64px;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    padding: 80px 16px 32px;
  }

  .ThreeTiles__Container {
    overflow: hidden;
    max-width: 1584px;
    width: 100%;
    margin: 0px auto;
  }

  .ThreeTiles__MainTitle {
    text-align: center;
    max-width: 1140px;
    margin: 0 auto 64px;
    ${({ theme }) => theme.breakpoints.down('xs')} {
      margin-bottom: 24px;
    }
  }

  .ThreeTiles__Cards {
    margin: 64px 0px 24px;
    display: flex;

    ${({ theme }) => theme.breakpoints.down('xs')} {
      flex-direction: column;
      margin-top: 52px;
    }
    .tile-box {
      padding: 24px;
      width: calc(33.333% - 24px);
      background-color: ${({ theme }) => theme.webMktNewPalette.white};
      margin: 0px 12px;
      ${({ theme }) => theme.breakpoints.down('xs')} {
        width: calc(100% - 48px);
        margin: 12px 0px;
        text-align: center;
      }

      .icon {
        margin-bottom: 16px;
        img {
          width: 96px;
          height: 96px;
        }
      }

      .title {
        margin-bottom: 16px;
      }
    }
  }

  .ThreeTiles__Bottom {
    text-align: center;
    .ThreeTiles__MainDesc {
      text-align: center;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px;
      letter-spacing: -0.5px;
      margin-bottom: 24px;
    }
  }

  .ThreeTiles__VideoThumbnail {
    text-align: center;
    position: relative;

    > img {
      object-fit: cover;
      object-position: center;
    }

    .ThreeTiles__playVideo {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .VideoPlayer > div:after {
        content: '';
        display: block;
        z-index: 2;
        position: absolute;
        margin: 0 auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 96px;
        height: 96px;
        opacity: 0.8;
        transition: opacity 0.5s ease-in-out;
        background: url(ASSETS.Video_Play_Icon) center / 100% no-repeat;
      }
    }
  }
`
